import React from "react"
import styled from "styled-components"

import { Button, FormControl } from "react-bootstrap"
import { getBranchUserData } from "../../../../utils"
import Checkbox from "../../../../_components/Checkbox"

const WhatsAppIconButton = styled(Button)`
position: fixed !important;
bottom: 40px;
right: 10px;
    border-bottom: 3px ;
`
const WhatsAppBoxDialog = styled.div`
    background-color: #ebebeb
    min-height: 500px !important
    max-height: 400px !important
    min-width: 300px !important
    max-width: 300px !important
    position: fixed !important
    bottom: 40px
    padding: 15px
    right: 60px
    border-radius: 20px
    display: flex
    flex-direction: column
    justify-content: center

    /* From https://css.glass */
    background: rgba(255, 255, 255, 0.2);
    border-radius: 16px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);
    border: 1px solid rgba(255, 255, 255, 0.3);
`
const WhatsAppBoxDialogInner = styled.div`
    background-color: white
    min-height: 350px !important
    padding: 10px
    display: flex
    flex-direction: column
    justify-content: space-between

`

const DepartamentSection = styled.div`
    background-color: #1ab394
    display: flex
    flex-direction: row
    justify-content: flex-start
    padding: 10px
    border-radius: 6px
    cursor: pointer
    margin-bottom: 10px
    opacity: 1

    span {
        font-weight: bold
        color: white
    }

    :hover{
        opacity: .7
    }
`
const widgetsTexts = [
    {
        "label": "Parcerias e Projetos",
        "text": "Olá, quero falar sobre Parcerias e Projetos"
    },
    {
        "label": "Financeiro",
        "text": "Olá, quero falar com o financeiro"
    },
    {
        "label": "Certificado Digital",
        "text": "Olá, quero falar sobre Certificado Digital"
    },
    {
        "label": "Suporte Técnico",
        "text": "Olá, quero falar com suporte técnico"
    },
    {
        "label": "Atendimento e preços",
        "text": "Olá, quero falar sobre atendimento e preços"
    }
]
export default props => {

    const [input, setInput] = React.useState("")
    const [departamentText, setDepartamentText] = React.useState("")

    function setInputFocus() {
        try { document.getElementById("textarea-input-reason-to-call-support").focus() } catch (error) { }
    }

    function sendZap() {
        const branchData = getBranchUserData()

        let tempInput = input.length? `, além disso, ${input}` : ''

        const message = `${departamentText}${tempInput} - ${branchData}
        `
        toggle()
        setDepartamentText("")
        setInput("")
        window.open(`https://wa.me/5511966466526?&text=${message}`, "__blank")
    }

    React.useEffect(setInputFocus, [departamentText])

    function toggle() {
        const el = document.getElementById("footer-whatsapp-footer-button")
        if (el.classList.contains("d-none")) {
            el.classList.remove("d-none")
            try { document.getElementById("textarea-input-reason-to-call-support").focus() } catch (error) { }
        } else {
            el.classList.add("d-none")
        }
    }
    return <div className="">
        <WhatsAppIconButton onClick={toggle} className="">
            <i class="fab fa-whatsapp fa-2x"></i>
        </WhatsAppIconButton>
        <WhatsAppBoxDialog id="footer-whatsapp-footer-button" className="d-none">
            <WhatsAppBoxDialogInner>
                <div className="form-group">
                    <div className="form-label mb-2">
                        Selecione abaixo o departamento que você deseja atendimento
                    </div>
                    {
                        widgetsTexts.map((widget, index) => {
                            return <DepartamentSection key={`whatsapp-action-text-${index}`}
                                onClick={() => setDepartamentText(widget.text)}>
                                <Checkbox
                                    checked={departamentText === widget.text}
                                    value={widget.text} />
                                <span>
                                    {
                                        widget.label
                                    }
                                </span>
                            </DepartamentSection>
                        })
                    }
                </div>
                <div className={`${departamentText ? "d-block" : "d-none"}`}>
                    <div className="form-label">
                        Informe sua mensagem abaixo:
                    </div>
                    <FormControl
                        id="textarea-input-reason-to-call-support"
                        value={input}
                        autoFocus
                        cels={4}
                        onChange={e => setInput(e.target.value)}
                        as="textarea" />
                    <div className="d-flex justify-content-end">
                        <Button onClick={sendZap}>
                            Enviar WhatsApp <i className="fas fa-paper-plane"></i>
                        </Button>
                    </div>
                </div>
            </WhatsAppBoxDialogInner>
        </WhatsAppBoxDialog>
    </div >
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Footer/WhatsAppButton/index.jsx